import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest, delay, call } from "redux-saga/effects";
import { getCsrfToken } from "@utils/common";

export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  UserRequested: "[Request User] Action",
  UserLoaded: "[Load User] Auth API"
};

const initialAuthState = {
  user: undefined
};

export const reducer = persistReducer(
  { storage, key: "onpoint-app-auth", whitelist: ["user"] },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login:
        return state;

      case actionTypes.Logout:
        return initialAuthState;

      case actionTypes.UserLoaded:
        return { ...state, user: action.payload.user };

      default:
        return state;
    }
  }
);

export const actions = {
  login: () => ({ type: actionTypes.Login }),
  logout: () => ({ type: actionTypes.Logout }),
  requestUser: () => ({ type: actionTypes.UserRequested }),
  fulfillUser: (user) => ({ type: actionTypes.UserLoaded, payload: { user } })
};

// Retry function to get CSRF token
function* getCsrfTokenWithRetry(maxRetries = 3, delayMs = 500) {
  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    const csrfToken = getCsrfToken();
    if (csrfToken) return csrfToken;

    console.warn(`Retrying CSRF token retrieval (${attempt}/${maxRetries})...`);
    yield delay(delayMs);
  }
  throw new Error("CSRF token retrieval failed after retries.");
}

export function* saga() {
  yield takeLatest(actionTypes.Login, function* loginSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.UserRequested, function* userRequested() {
    try {
      // Retry getting CSRF token up to 3 times
      const csrfToken = yield call(getCsrfTokenWithRetry, 3, 500);

      const response = yield fetch("/api/user/me", {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken
        }
      });

      if (!response.ok) throw new Error("User fetch failed");

      const data = yield response.json();
      yield put(actions.fulfillUser(data));
    } catch (error) {
      console.error("User fetch error:", error);
    }
  });
}
